<template>
    <h2
        class="text-xl tablet-sm:text-3xl font-semibold mobile-lg:font-bold font-subtitle
               px-0 tablet-sm:px-1
               mx-0
               mb-1 pb-1 tablet-sm:mb-4 tablet-sm:pb-4
               mt-4 tablet-sm:mt-8
               text-3xl font-bold tracking-tight text-gray-900 sm:text-3xl"
    >
        <span  class="border-b-2 border-accent"><slot></slot></span>
    </h2>
</template>
